//user side ExamPage.js

import { useEffect, useState } from "react";
import API from "../services/api";
import { Container, Row, Col, Card, Button, Modal } from "react-bootstrap";

const ExamPage = () => {
  const [showNetworkModal, setShowNetworkModal] = useState(false);
  const [showFullscreenModal, setShowFullscreenModal] = useState(false);
  const [questions, setQuestions] = useState([]);
  const [answers, setAnswers] = useState({});
  const [current, setCurrent] = useState(0);
  const [review, setReview] = useState({});
  const EXAM_DURATION = 60 * 60;

  const [timeLeft, setTimeLeft] = useState(() => {
    const start = localStorage.getItem("exam_start_time");
  
    if (!start) return EXAM_DURATION;
  
    const elapsed = Math.floor((Date.now() - start) / 1000);
    const remaining = EXAM_DURATION - elapsed;
  
    return remaining > 0 ? remaining : 0;
  });
  const [navPage, setNavPage] = useState(0);
const QUESTIONS_PER_PAGE = 50;
const [isSubmitting, setIsSubmitting] = useState(false);
const [isRestored, setIsRestored] = useState(false);

useEffect(() => {
  const ping = async () => {
    try {
      await API.get("/auth/ping.php"); // create simple API
    } catch (err) {
      console.log("Ping failed");
    }
  };

  const interval = setInterval(ping, 60000); // every 2 min

  return () => clearInterval(interval);
}, []);

useEffect(() => {
  const handleOffline = () => {
    console.log("Offline detected");
    setShowNetworkModal(true);
  };

  const handleOnline = () => {
    console.log("Back online");
    setShowNetworkModal(false);
  };

  window.addEventListener("offline", handleOffline);
  window.addEventListener("online", handleOnline);

  return () => {
    window.removeEventListener("offline", handleOffline);
    window.removeEventListener("online", handleOnline);
  };
}, []);

useEffect(() => {

  const savedAnswers = localStorage.getItem("exam_answers");
  if (savedAnswers) {
    setAnswers(JSON.parse(savedAnswers));
  }


  const savedReview = localStorage.getItem("exam_review");
  if (savedReview) {
    setReview(JSON.parse(savedReview));
  }


  const savedCurrent = localStorage.getItem("exam_current");
  if (savedCurrent !== null) {
    setCurrent(parseInt(savedCurrent));
  }

  setIsRestored(true);
}, []);

useEffect(() => {
  if (!localStorage.getItem("exam_start_time")) {
    localStorage.setItem("exam_start_time", Date.now());
  }
}, []);

useEffect(() => {
  if (isSubmitting) return;

  const timer = setInterval(() => {
    const start = localStorage.getItem("exam_start_time");

    if (!start) return;

    const elapsed = Math.floor((Date.now() - start) / 1000);
    const remaining = EXAM_DURATION - elapsed;

    if (remaining <= 0) {
      clearInterval(timer);
      setTimeLeft(0);

      setTimeout(() => handleSubmit(), 300);
    } else {
      setTimeLeft(remaining);
    }
  }, 1000);

  return () => clearInterval(timer);
}, [isSubmitting]);


useEffect(() => {
  if (localStorage.getItem("exam_submitted") === "true") {
    window.location.href = "/result";
  }
}, []);

useEffect(() => {
  const saved = localStorage.getItem("exam_answers");
  if (saved) {
    setAnswers(JSON.parse(saved));
  }
  setIsRestored(true); 
}, []);

useEffect(() => {
  if (!isRestored) return; 

  localStorage.setItem("exam_answers", JSON.stringify(answers));
}, [answers, isRestored]);

useEffect(() => {
  if (!isRestored) return;  
  localStorage.setItem("exam_review", JSON.stringify(review));
}, [review, isRestored]);

useEffect(() => {
  if (!isRestored) return;   
  localStorage.setItem("exam_current", current);
}, [current, isRestored]);

useEffect(() => {
  document.body.style.overflow = "hidden";

  const handleExit = () => {
    if (!document.fullscreenElement) {
      setShowFullscreenModal(true);
    }
  };

  const handleVisibilityChange = () => {
    if (document.hidden) {
      setTimeout(() => handleSubmit(), 500);
    }
  };

  const handleBlur = () => {
    setTimeout(() => handleSubmit(), 500);
  };


  const handleRightClick = (e) => {
    e.preventDefault();
  };


  const handleKeyDown = (e) => {
    if (
      e.key === "F12" ||
      (e.ctrlKey && e.shiftKey && e.key === "I") ||
      (e.ctrlKey && e.key === "u") ||
      (e.ctrlKey && e.key === "c") ||
      (e.ctrlKey && e.key === "v")
    ) {
      e.preventDefault();
    }
  };


  document.addEventListener("fullscreenchange", handleExit);
  document.addEventListener("visibilitychange", handleVisibilityChange);
  window.addEventListener("blur", handleBlur);
  document.addEventListener("contextmenu", handleRightClick);
  document.addEventListener("keydown", handleKeyDown);
  
  
  return () => {
    document.body.style.overflow = "auto";
    document.removeEventListener("fullscreenchange", handleExit);
    document.removeEventListener("visibilitychange", handleVisibilityChange);
    window.removeEventListener("blur", handleBlur);
    document.removeEventListener("contextmenu", handleRightClick);
    document.removeEventListener("keydown", handleKeyDown);
  };
}, []);



  const formatTime = (t) => {
    const m = String(Math.floor(t / 60)).padStart(2, "0");
    const s = String(t % 60).padStart(2, "0");
    return `${m}:${s}`;
  };


  useEffect(() => {
    const fetch = async () => {
      const fd = new FormData();
      fd.append("session_id", localStorage.getItem("session_id"));
      fd.append("paper_id", localStorage.getItem("paper_id"));
      fd.append("code", localStorage.getItem("exam_code"));

      const res = await API.post("/auth/get-questions.php", fd);
      setQuestions(res.data.questions || []);
    };
    fetch();
  }, []);

  const currentQ = questions[current] || {};
  const startIndex = navPage * QUESTIONS_PER_PAGE;
  const endIndex = startIndex + QUESTIONS_PER_PAGE;
  const visibleQuestions = questions.slice(startIndex, endIndex);

  const getStatus = (index) => {
    const q = questions[index];
    if (!q) return "notVisited";
  
    if (index === current) return "current";
  
    if (review[q.id]) return "review";
  
    if (
      answers[q.id] !== undefined &&
      answers[q.id] !== null &&
      answers[q.id] !== ""
    ) {
      return "answered";
    }
  
    return "notVisited";
  };


const answeredCount = questions.filter(q =>
  answers[q.id] !== undefined &&
  answers[q.id] !== null &&
  answers[q.id] !== ""
).length;

const reviewCount = Object.values(review).filter(v => v === true).length;

const notVisitedCount = questions.filter(q =>
  answers[q.id] === undefined &&
  !review[q.id]
).length;

const currentQuestionNumber = current + 1;




const handleSubmit = async () => {
  if (isSubmitting) return;
  if (localStorage.getItem("exam_submitted") === "true") return;

  setIsSubmitting(true);
  localStorage.setItem("exam_submitted", "true");

  const latestAnswers = localStorage.getItem("exam_answers");

  const submissionData = {
    session_id: localStorage.getItem("session_id"),
    paper_id: localStorage.getItem("paper_id"),
    answers: latestAnswers || JSON.stringify(answers),
    code: localStorage.getItem("exam_code"),
  };

  localStorage.setItem("pending_submission", JSON.stringify(submissionData));

  let networkTimer;

  try {
    const fd = new FormData();
    Object.keys(submissionData).forEach(k => fd.append(k, submissionData[k]));

    // ⏳ delay showing modal
    networkTimer = setTimeout(() => {
      setShowNetworkModal(true);
    }, 5000);

    const res = await API.post("/auth/submit-exam.php", fd, {
      timeout: 15000
    });

    clearTimeout(networkTimer);

    if (res.data.status === "success") {
      setShowNetworkModal(false);

      localStorage.removeItem("pending_submission");
      localStorage.removeItem("exam_answers");
      localStorage.removeItem("exam_start_time");
      localStorage.removeItem("exam_review");
      localStorage.removeItem("exam_current");

      window.location.href = "/result";
      return;
    }

  } catch (err) {
    clearTimeout(networkTimer);
    console.log("⚠️ First request failed, retrying in background");
    setShowNetworkModal(true); // now show (real failure)
  }

  setIsSubmitting(false);
};

  useEffect(() => {
    const retrySubmission = async () => {
      const pending = localStorage.getItem("pending_submission");
      if (!pending) return;
  
      const data = JSON.parse(pending);
  
      try {
        const fd = new FormData();
        Object.keys(data).forEach(k => fd.append(k, data[k]));
  
        const res = await API.post("/auth/submit-exam.php", fd);
  
        if (res.data.status === "success") {
          console.log("✅ Background submission success");
  
          localStorage.removeItem("pending_submission");
  
          // clean exam data
          localStorage.removeItem("exam_answers");
          localStorage.removeItem("exam_start_time");
          localStorage.removeItem("exam_review");
          localStorage.removeItem("exam_current");
  
          window.location.href = "/result";
        }
  
      } catch (err) {
        console.log("⏳ Still waiting for network...");
      }
    };
  
  
    const interval = setInterval(retrySubmission, 5000);
  
    return () => clearInterval(interval);
  }, []);

  if (!questions || questions.length === 0) {
    return (
      <div className="text-center mt-5">
        <h5>Loading questions...</h5>
      </div>
    );
  }

  const goFullScreen = () => {
    const el = document.documentElement;
  
    if (el.requestFullscreen) {
      el.requestFullscreen().catch(() => {});
    }
  
    setShowFullscreenModal(false);
  };

  const submitFromModal = () => {
    setShowFullscreenModal(false);
    handleSubmit();
  };

  

  return (
    <div className="exam-page">

      {/* HEADER */}
      <div className="exam-header">
        <div>
          <h5 className="fw-bold mb-0">Cyber Security Assessment</h5>
          <small className="text-muted">
            {Object.keys(answers).length}/{questions.length} answered
          </small>
        </div>

        <div className="d-flex align-items-center gap-3">
        <div className="timer-box" style={{
  background: timeLeft < 60 ? "#ffe5e5" : "#eef6ff",
  color: timeLeft < 60 ? "red" : "black"
}}>
  ⏱ {formatTime(timeLeft)}
</div>
          <Button 
  className="submit-btn" 
  onClick={handleSubmit}
  disabled={isSubmitting || timeLeft === 0}
>
  {isSubmitting ? "Submitting..." : "Submit"}
</Button>
        </div>
      </div>

 
      <Container fluid className="mt-4">
        <Row>

        
          <Col md={9}>
            <Card className="question-card">
              <Card.Body>

                <div className="d-flex justify-content-between mb-3">
                  <span className="badge bg-light text-primary">
                    Q{current + 1}/{questions.length}
                  </span>

                  <Button
  size="sm"
  variant={review[currentQ?.id] ? "warning" : "outline-secondary"}
  onClick={() => {
    if (!currentQ?.id) return;

    setReview(prev => ({
      ...prev,
      [currentQ.id]: !prev[currentQ.id] 
    }));
  }}
>
  {review[currentQ?.id] ? "Marked" : "Mark for Review"}
</Button>
                </div>

                <h5 className="fw-bold mb-4">{currentQ?.question}</h5>

             
{currentQ?.type === "mcq" ? (
  ["a", "b", "c", "d"].map((opt) => (
    <div
      key={opt}
      className={`option-box ${
        answers[currentQ?.id] === currentQ?.[`option_${opt}`]
          ? "active"
          : ""
      }`}
      onClick={() => {
        if (!currentQ?.id) return;

        setAnswers(prev => ({
          ...prev,
          [currentQ.id]: currentQ[`option_${opt}`]
        }));

  
        setReview(prev => ({
          ...prev,
          [currentQ.id]: false
        }));
      }}
    >
      <span className="me-3 fw-bold">{opt.toUpperCase()}.</span>
      {currentQ?.[`option_${opt}`]}
    </div>
  ))
) : (
  <div className="mt-3">
    <input
      type="text"
      className="form-control fill-input"
      placeholder="Enter your answer..."
      value={answers[currentQ?.id] || ""}
      onChange={(e) => {
        if (!currentQ?.id) return;

        setAnswers(prev => ({
          ...prev,
          [currentQ.id]: e.target.value
        }));
      }}
    />
  </div>
)}

       
                <div className="d-flex justify-content-between mt-4">
  <Button
                    disabled={current === 0}
    onClick={() => {
                      if (current > 0) {
      const prevIndex = current - 1;
      setCurrent(prevIndex);

                    
      if (prevIndex < startIndex) {
        setNavPage(navPage - 1);
                        }
      }
    }}
  >
    Previous
  </Button>

                  {current < questions.length - 1 && (
  <Button
    onClick={() => {
      const nextIndex = current + 1;
      setCurrent(nextIndex);

      if (nextIndex >= endIndex) {
        setNavPage(navPage + 1);
      }
    }}
  >
    Next
  </Button>
)}
                </div>

              </Card.Body>
            </Card>
          </Col>

      
          <Col md={3}>
            <Card className="navigator-card">
              <Card.Body>

                <h6 className="fw-bold mb-3">Question Navigator</h6>

                <div className="grid">
                {visibleQuestions.map((q, i) => {
  const realIndex = startIndex + i;

  return (
    <div
      key={realIndex}
      className={`nav-btn ${getStatus(realIndex)}`}
      onClick={() => setCurrent(realIndex)}
    >
      {realIndex + 1}
    </div>
  );
})}
                </div>

                <div className="d-flex justify-content-between mt-3">

  <Button
    size="sm"
    disabled={navPage === 0}
    onClick={() => setNavPage(navPage - 1)}
  >
    ← Prev
  </Button>

  <span className="small text-muted">
    {startIndex + 1} - {Math.min(endIndex, questions.length)} of {questions.length}
  </span>

  <Button
    size="sm"
    disabled={endIndex >= questions.length}
    onClick={() => setNavPage(navPage + 1)}
  >
    Next →
  </Button>

</div>

             
                <div className="mt-4 small d-flex gap-3 flex-wrap px-3 justify-content-center">

  <div>
    <span className="dot answered"></span>
    Answered ({answeredCount})
  </div>

  <div>
    <span className="dot review"></span>
    Review ({reviewCount})
  </div>

  <div>
    <span className="dot notVisited"></span>
    Not Visited ({notVisitedCount})
  </div>

  <div>
    <span className="dot current"></span>
    Current (Q{currentQuestionNumber})
  </div>

</div>

              </Card.Body>
            </Card>
          </Col>

        </Row>
      </Container>

    
      <style>{`
        .exam-page {
          background: #f5f7fb;
          min-height: 100vh;
        }

        .exam-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 15px 30px;
          background: #fff;
          border-bottom: 2px solid #eaeaea;
        }

        .timer-box {
          background: #eef6ff;
          padding: 8px 15px;
          border-radius: 10px;
          font-weight: bold;
        }

        .submit-btn {
          background: linear-gradient(90deg, #0d6efd, #20c997);
          border: none;
        }

        .question-card {
          border-radius: 15px;
          box-shadow: 0 10px 25px rgba(0,0,0,0.08);
        }

        .option-box {
          padding: 12px;
          border: 1px solid #ddd;
          border-radius: 10px;
          margin-bottom: 10px;
          cursor: pointer;
          transition: 0.2s;
        }

        .option-box:hover {
          background: #f0f7ff;
        }

        .option-box.active {
          border-color: #0d6efd;
          background: #e6f0ff;
        }

        .navigator-card {
          border-radius: 15px;
        }

        .grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 10px;
  max-height: 300px;
  overflow-y: auto;
}

        .nav-btn {
          height: 40px;
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          border: 1px solid #ddd;
        }

        .nav-btn.answered {
          background: #d4edda;
        }

        .nav-btn.review {
  background: #ffc107 !important;
  color: #000;
  font-weight: bold;
}

        .nav-btn.current {
          border: 2px solid #0d6efd;
        }

        .nav-btn.notVisited {
          background: #f8f9fa;
        }

        .dot {
          display: inline-block;
          width: 10px;
          height: 10px;
          border-radius: 50%;
          margin-right: 5px;
        }

        .fill-input {
  padding: 12px;
  border-radius: 10px;
  border: 1px solid #ddd;
  font-size: 16px;
}

.fill-input:focus {
  border-color: #0d6efd;
  box-shadow: 0 0 0 2px rgba(13,110,253,0.2);
}

        .dot.answered { background: green; }
        .dot.review { background: orange; }
        .dot.notVisited { background: gray; }
        .dot.current { background: blue; }

      `}</style>

<Modal show={showFullscreenModal} centered backdrop="static" keyboard={false}>
  <Modal.Body className="text-center p-4">

    <h5 className="fw-bold mb-3 text-danger">
      ⚠️ Fullscreen Required
    </h5>

    <p className="text-muted mb-4">
      Please stay in fullscreen during the exam and don't switch the tabs.  
      <br />
      Otherwise your exam will be submitted automatically.
    </p>

    <div className="d-flex justify-content-center gap-3">

      <Button
        variant="outline-primary"
        onClick={goFullScreen}
      >
        Cancel
      </Button>

      <Button
        variant="danger"
        onClick={submitFromModal}
      >
        Submit Exam
      </Button>

    </div>

  </Modal.Body>
</Modal>

<Modal show={showNetworkModal} centered backdrop="static" keyboard={false}>
  <Modal.Body className="text-center p-4">

    <h5 className="fw-bold mb-3 text-warning">
      ⚠️ Submitting Your Exam
    </h5>

    <p className="text-muted mb-3">
      Please do NOT refresh or close this page.
    </p>

    <p className="text-danger mb-3">
      Your internet connection is slow or disconnected.
    </p>

    <p className="small text-muted">
      Don't worry — your answers are saved safely and will be submitted automatically once connection is stable.
    </p>

    <div className="mt-3">
      <div className="spinner-border text-primary"></div>
    </div>

  </Modal.Body>
</Modal>



    </div>
  );
};

export default ExamPage;